import React from 'react';
import { useLanguage, type Language } from '../contexts/LanguageContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

interface LanguageSelectProps {
  className?: string;
  triggerClassName?: string;
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ className, triggerClassName }) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className={className}>
      <Select value={language} onValueChange={(value) => setLanguage(value as Language)}>
        <SelectTrigger className={triggerClassName} aria-label={t('language')}>
          <SelectValue placeholder={t('language')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="az">🇦🇿 AZ</SelectItem>
          <SelectItem value="en">🇬🇧 EN</SelectItem>
          <SelectItem value="ru">🇷🇺 RU</SelectItem>
          <SelectItem value="tr">🇹🇷 TR</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelect;
